__turbopack_context__.v({
  "acctShimmer": "AccountChrome-module__XRxo6q__acctShimmer",
  "avatarImage": "AccountChrome-module__XRxo6q__avatarImage",
  "avatarSkeleton": "AccountChrome-module__XRxo6q__avatarSkeleton",
  "breadcrumbs": "AccountChrome-module__XRxo6q__breadcrumbs",
  "grid": "AccountChrome-module__XRxo6q__grid",
  "nav": "AccountChrome-module__XRxo6q__nav",
  "navGroupLabel": "AccountChrome-module__XRxo6q__navGroupLabel",
  "navIcon": "AccountChrome-module__XRxo6q__navIcon",
  "navItem": "AccountChrome-module__XRxo6q__navItem",
  "navItemActive": "AccountChrome-module__XRxo6q__navItemActive",
  "page": "AccountChrome-module__XRxo6q__page",
  "pageTitle": "AccountChrome-module__XRxo6q__pageTitle",
  "panel": "AccountChrome-module__XRxo6q__panel",
  "profileBadges": "AccountChrome-module__XRxo6q__profileBadges",
  "profileCard": "AccountChrome-module__XRxo6q__profileCard",
  "profileEmail": "AccountChrome-module__XRxo6q__profileEmail",
  "profileMeta": "AccountChrome-module__XRxo6q__profileMeta",
  "profileName": "AccountChrome-module__XRxo6q__profileName",
  "sidebar": "AccountChrome-module__XRxo6q__sidebar",
  "sidebarCard": "AccountChrome-module__XRxo6q__sidebarCard",
  "wrapper": "AccountChrome-module__XRxo6q__wrapper",
});
